import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import { FormGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import { withTranslation } from 'react-i18next';
import batchGoLogo from '../../../img/batchgo_blk.svg';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      username: '',
    };
    this.setInitialState();
  }

  componentDidMount () {
    const { connectionStore } = this.props;
    connectionStore.check();
  }

  async setInitialState () {
    const { newAuthStore } = this.props;
    const data = await newAuthStore.getOfflineLoginData();

    if (data?.email) {
      this.setState({
        username: data?.email,
      });
    } else {
      this.setState({
        error: 'Offline login data is missing. You need to login online at least once to use the offline mode.',
      });
    }
  }

  clearError = () => this.setState({ error: '' });

  render() {
    const { newAuthStore, t } = this.props;
    const { error, username } = this.state;

    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={
            {
              username,
            }
          }
          onSubmit={async (values, actions) => {
            this.clearError();
            try {
              await newAuthStore.offlineLogin(values.username);
            } catch (error) {
              this.setState({ error: error.message });
              actions.setSubmitting(false);
            }
          }}
        >{({ handleSubmit,
            values,
            isSubmitting,
          }) => (
            <div className="login fade-in-up">
              <div className="content">
                <form className="login-form" onSubmit={handleSubmit} method="post">
                  <img
                    className="logo"
                    src={batchGoLogo}
                    alt="BatchGo"
                  />
                  {error &&
                    <p className={'text-danger'}>{error}</p>
                  }
                  <FormGroup>
                    <label className="control-label visible-ie8 visible-ie9">{t('Username')}</label>
                    <input className="form-control form-control-solid placeholder-no-fix"
                      type="text"
                      autoComplete="off"
                      disabled={true}
                      placeholder={t('Username')}
                      name="username"
                      data-testid="input-login"
                      value={values.username || ''}
                    />
                  </FormGroup>
                  <div className="form-actions">
                    <LoadingButton
                      className="btn-block uppercase"
                      bsStyle="primary"
                      type="submit"
                      label={t('Offline Access')}
                      loadingLabel="Login"
                      isLoading={isSubmitting}
                    />
                  </div>
                </form>
              </div>
            </div>
          )}
        </Formik>
      </div>
    );
  };
}

export default withTranslation()(inject('newAuthStore', 'connectionStore')(observer(Login)));
